// extracted by mini-css-extract-plugin
export default {"price":"R6-z","onSale":"S6-z","msrpLabelPrice":"T6-z","msrpLabel":"U6-z","originalPrice":"V6-z","percentOff":"W6-z"};